var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorchecking = function SvgErrorchecking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M56 28c0 15.464-12.536 28-28 28S0 43.464 0 28 12.536 0 28 0s28 12.536 28 28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EAEE",
    d: "M44.982 28c0 9.38-7.602 16.98-16.981 16.98S11.02 37.38 11.02 28 18.621 11.02 28 11.02 44.98 18.62 44.98 28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EAEE",
    d: "m19.038 42.416-7.451 1.996 1.997-7.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D6D7E",
    d: "m40.908 39.065-1.842 1.842-2.618-2.62 1.841-1.841z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37517E",
    d: "M41.55 28c0 7.483-6.067 13.548-13.55 13.548-7.48 0-13.547-6.065-13.547-13.549 0-7.481 6.066-13.547 13.548-13.547s13.548 6.066 13.548 13.547"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F8FB",
    d: "M38.838 28c0 5.988-4.849 10.839-10.837 10.839s-10.84-4.851-10.84-10.84c0-5.986 4.853-10.838 10.84-10.838 5.988 0 10.837 4.852 10.837 10.838"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B9FF",
    d: "M35.406 28a7.404 7.404 0 0 1-7.405 7.406A7.406 7.406 0 0 1 20.594 28 7.406 7.406 0 0 1 28 20.594 7.404 7.404 0 0 1 35.406 28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34495E",
    d: "M31.432 28a3.432 3.432 0 1 1-6.866.001A3.432 3.432 0 0 1 31.433 28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F8FB",
    d: "M27.818 25.83a1.987 1.987 0 1 1-3.974.002 1.987 1.987 0 0 1 3.974-.002"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37517E",
    d: "m49.531 45.901-7.849-7.848-3.628 3.628 7.85 7.85a2.566 2.566 0 1 0 3.627-3.63"
  }))));
};
export default SvgErrorchecking;